import axios from 'axios';
import https from 'https';

import { isSSR } from '../helpers';

const readHudsonInternalCA = () => {
    const hybrisInternalCA = process.env.HUDSON_INTERNAL_CA_CERT;
    if (hybrisInternalCA) {
        try {
            return Buffer.from(hybrisInternalCA, 'base64');
        } catch {
            // No op
        }
    }

    return null;
};

const getSSRHttpsAgent = () => {
    const hudsonInternalCA = readHudsonInternalCA();

    return new https.Agent({
        ca: hudsonInternalCA ? hudsonInternalCA : undefined,
        rejectUnauthorized: !hudsonInternalCA ? false : undefined,
    });
};

export const axiosForAnonymousHudson = axios.create(
    isSSR()
        ? {
              httpsAgent: getSSRHttpsAgent(),
              baseURL: process.env.HUDSON_INTERNAL_URL,
          }
        : {
              httpsAgent: undefined,
              baseURL: process.env.IS_PROXY_MODE === 'true' ? undefined : process.env.HUDSON_PUBLIC_URL,
          },
);
